"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import Image from "next/image";
import Link from 'next/link';
import { Autoplay, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/pagination";
import LocalizedClientLink from "@modules/common/components/localized-client-link";
import { CreditCard, Gift, Megaphone, Truck } from "lucide-react";


const Carousel = ({
  data,
}: {
  data: {
    image: string;
    title: string;
    info: string;
    price: string;
    button: string;
  }[];
}) => {

  const slides = [
    {
      title: 'Promoción reapertura',
      href: 'es/store',
      desktopImage: '/images/slide/reapertura.webp',
      mobileImage: '/images/slide/reapertura.webp'
      // desktopImage: 'https://minio.desarrollosdelcabo.es/api/v1/buckets/farmaciapaseo51/objects/download?preview=true&prefix=reapertura.webp&version_id=null',
      // mobileImage: 'https://minio.desarrollosdelcabo.es/api/v1/buckets/farmaciapaseo51/objects/download?preview=true&prefix=reapertura.webp&version_id=null',
    },
    {
      title: 'Promoción Avene',
      href: 'es/categories/protectores-solares-corporales',
      desktopImage: '/images/slide/1.webp',
      mobileImage: '/images/slide/1.webp'
    },
    {
      title: '30% descuento solares',
      href: 'es/store?tags=Solares%20Anthelios%2030%25%20Descuento,Solares%20Avene%2020%25%20Descuento,Solares%20Bioderma%2050%25%20Descuento,Solares%20Vichy%2025%25%20Descuento',
      desktopImage: '/images/promociones/30_por_ciento_descuento_solares.webp',
      mobileImage: '/images/promociones/30_por_ciento_descuento_solares.webp'
    },
    {
      title: 'Zzzquil -3€ descansa mejor',
      href: 'es/store?tags=Zzzquil%20Natural%2030%20Gummies%20-3%20euros',
      desktopImage: '/images/promociones/3_euros_descuento_zzzquil_descansa_mejor.webp',
      mobileImage: '/images/promociones/3_euros_descuento_zzzquil_descansa_mejor.webp'
    },
    {
      title: '5% descuento encuesta pedido',
      href: '#',
      desktopImage: '/images/promociones/5_por_ciento_descuento_encuesta_pedido.webp',
      mobileImage: '/images/promociones/5_por_ciento_descuento_encuesta_pedido.webp'
    }
  ];


  return (
    <div className="main-slider-container">
      <Swiper
        modules={[Pagination, Autoplay]} // Enable Pagination and Autoplay
        spaceBetween={0} // No space between slides
        slidesPerView={1} // Show one slide at a time
        pagination={{ clickable: true }} // Enable clickable pagination dots
        autoplay={{
          delay: 5000, // 5 seconds delay between slides
          disableOnInteraction: false, // Continue autoplay even after user interaction
        }}
        loop={true} // Loop through slides
        className="mySwiper"
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <Link href={slide.href} className="block">
               <div className="slide-content">
                   <Image
                        className="slide-image"
                        src={slide.desktopImage}
                        alt={slide.title}
                      sizes="(max-width: 640px) 100vw, 1200px"
                      width={2000}
                      height={1000}
                      // T12: primer slide = LCP → priority (preload + sin
                      // lazy). fetchPriority explícito porque en componentes
                      // client (Swiper) Next.js no pinta el atributo en el
                      // <img> ni en el preload (verificado en producción,
                      // auditoría Lighthouse 2026-08-25). El resto sigue lazy.
                      priority={idx === 0}
                      fetchPriority={idx === 0 ? "high" : undefined}
                      />
                {/* <img
                  src={slide.desktopImage}
                  alt={slide.title}
                  className="slide-image hidden sm:block"
                />
                <img
                  src={slide.mobileImage}
                  alt={slide.title}
                  className="slide-image sm:hidden"
                /> */}
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="feature-grid">
        <div className="feature-item">
          <Truck />
          <div className="feature-text">
            <strong>ENVÍOS 24H - 72H</strong><br />
            GRATIS Para pedidos superiores a 60€ - 
            <LocalizedClientLink href="/envios-devoluciones" className="underline"> Ver condiciones.</LocalizedClientLink>
          </div>
        </div>
        <div className="feature-item">
          <CreditCard />
          <div className="feature-text">
            <strong>ENCARGOS</strong><br />
             <LocalizedClientLink href="/encargos" className="underline">Haz click aquí para realizar un encargo o pedir precio sin compromiso.</LocalizedClientLink> 
          </div>
        </div>
        <div className="feature-item">
          <Megaphone />          <div className="feature-text">
            <strong>ATENCIÓN PERSONALIZADA</strong><br />
            Recibe asesoramiento de farmacéuticos
          </div>
        </div>
        <div className="feature-item">
          <Gift />          <div className="feature-text">
            <strong>MUESTRAS DE REGALO</strong><br />
            Recibe muestras GRATIS en todos tus pedidos
          </div>
        </div>
      </div>

      {/* Banner Click & Collect */}
      <div className="click-collect-banner">
        {/* <Link href="/es/click-and-collect"> */}
        <Image
          // T12: variante webp (13 KB vs 1,3 MB PNG) y SIN priority — está
          // fuera del LCP (debajo del hero) y antes precargaba w=3840.
          src="/images/banners/banner_parking.webp"
          alt="Click & Collect: compra online y recoge en tienda · 1 hora de parking gratis"
          width={1200}
          height={357}
          className="click-collect-img"
        />
        {/* </Link> */}
        <div className="click-collect-text feature-text">
          {/* Auditoría a11y 2026-08-25: era <h3> saltando de nivel
              (h1 → h3 → h2). Ahora h2 = sección del banner. */}
          <h2>Click & Collect</h2>
          <p>Por tu compra online 1 hora de parking gratis</p>
          <LocalizedClientLink href="/envios-devoluciones" className="ver-condiciones">
            Ver condiciones
          </LocalizedClientLink>
        </div>
      </div>

      <style jsx>{`
        .main-slider-container {
          position: relative;
          width: 100%;
          max-width: 1200px; /* Adjust as needed */
          margin: 20px auto;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          overflow: hidden; /* Ensures image corners are rounded */
        }

        

        .mySwiper {
          width: 100%;
          height: 350px; /* Adjust height as needed */
        }

        .slide-content {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .slide-image {
          width: 100%;
          height: 100%;
          object-fit: cover; /* Ensures image covers the area */
        }

        .overlay-content {
          position: absolute;
          left: 10%; /* Adjust position of text/button */
          top: 50%;
          transform: translateY(-50%);
          color: #333; /* Text color */
          text-align: left;
        }

        .discount-tag {
          font-size: 3.5em;
          font-weight: bold;
          color: #dc3545; /* Red for discount */
          line-height: 1;
        }

        .brand-name {
          font-size: 0.6em; /* Smaller for brand name */
          font-weight: normal;
          color: #555;
        }

        .slide-description {
          font-size: 1.2em;
          margin-top: 10px;
          color: #666;
        }

        .buy-button {
          display: inline-block;
          margin-top: 20px;
          padding: 10px 25px;
          background-color: #007bff; /* Blue button */
          color: white;
          text-decoration: none;
          border-radius: 5px;
          font-size: 1.1em;
          transition: background-color 0.3s ease;
        }

        .buy-button:hover {
          background-color: #0056b3;
        }

        /* Swiper pagination custom styles */
        :global(.swiper-pagination-bullet) {
          background: #ccc; /* Inactive dot color */
          opacity: 0.7;
        }

        :global(.swiper-pagination-bullet-active) {
          background: #007bff; /* Active dot color */
        }

        @media (max-width: 768px) {
          .mySwiper {
            height: 250px;
          }
          .overlay-content {
            left: 5%;
          }
          .discount-tag {
            font-size: 2.5em;
          }
          .slide-description {
            font-size: 1em;
          }
          .buy-button {
            padding: 8px 20px;
            font-size: 1em;
          }
        }

        @media (max-width: 480px) {
          .mySwiper {
            height: 180px;
          }
          .discount-tag {
            font-size: 1.8em;
          }
          .slide-description {
            font-size: 0.8em;
          }
          .buy-button {
            padding: 6px 15px;
            font-size: 0.9em;
            margin-top: 10px;
          }
        }

        .feature-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 20px 0;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.feature-item img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.feature-text {
  font-size: 0.9em;
  color: #333;
  line-height: 1.4;
}

/* Responsive */
@media (max-width: 768px) {
  .feature-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 16px;
  }

  .feature-text {
    font-size: 0.85em;
  }

  .feature-item {
    padding: 8px;
  }

  .feature-item img {
    width: 35px;
    height: 35px;
  }
}

.click-collect-banner {
    max-width: 1200px;
    margin: 30px auto 0;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    
  }

  .click-collect-img {
    width: 100%;
    height: auto;
    display: block;
  }

  .click-collect-text {
    padding: 15px 20px;
    background: #fff;
    color: #333;
    text-align: center;
    box-shadow: 0 -2px 4px rgba(0,0,0,0.05);
      border-radius: 8px;
  background-color: #f9f9f9;
  }

  .click-collect-text h2 {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .click-collect-text p {
    margin: 0;
    font-size: 0.95rem;
  }

  .ver-condiciones {
    display: inline-block;
    margin-top: 6px;
    font-size: 0.85rem;
    color: #007bff;
    text-decoration: underline;
  }

  .ver-condiciones:hover {
    text-decoration: none;
  }


      `}</style>
    </div>
  );
};

export default Carousel;
